export default __webpack_public_path__ + "static/finance-presentation-970070bee3ee165538614adf914a4ee5.png";